<mat-toolbar fxLayout="row">
  <div fxFlex="1 1 40%" fxFlex.gt-sm="70%">
    <a class="pointer mr-4" [routerLink]="'/home'">
      <img width="100px"  src="assets/icons/PayviderLogo.jpg"
    /></a>
    <ng-template [ngIf]="viewMenuItems">
      <button
        class="MSB16"
        mat-button
        routerLinkActive="active"
        (click)="navigateTo(item.route)"
        *ngFor="let item of menuItems"
        [fxShow]="item.showOnDesktop"
        [fxShow.xs]="item.showOnMobile"
        [fxShow.sm]="item.showOnTablet"
      >
        {{ item.label }}
      </button>
    </ng-template>
  </div>
  <div fxFlex="1 1 10%" fxHide.xs></div>

  <!-- <mat-icon
    fxFlex.gt-sm="2%"
    style="cursor: pointer; font-size: 2rem; color: #013cdb"
    (click)="toggleNav()"
  >
    mail_outline</mat-icon
  > -->
  <!-- <mat-icon
   fxFlex.gt-sm="2%"
  style="cursor: pointer; font-size: 2rem; color: #013cdb"
  (click)="toggleNav()" matBadge="{{count}}"
  matBadgePosition="after"  MatBadgeSize="large"
  
  >notifications_none</mat-icon> -->
  <mat-icon 
    class="ml-4 mr-3"
    fxFlex.gt-sm="2%"
    style="cursor: pointer; font-size: 2rem; color: #013cdb"
    (click)="searchClaims()"
    >search</mat-icon
  >

  <button
    fxFlex="1 1 50%"
    fxFlex.gt-sm="7%"
    class="m-2 mr-4 p-0 MSB16 align-middle buttonSmallPrimaryBlue"
    mat-raised-button
    aria-label="Add new Claim"
    [routerLink]="'/home/claim-initiation'"
  >
    <!-- <mat-icon>add</mat-icon>  -->
    <span> Add Claim </span>
  </button>

  <button
  *ngIf="enableProviderLending"
  class="m-2 mr-4 p-0 MSB16 align-middle buttonSmallPrimaryBlue"
  style="min-width: 150px;"
  mat-raised-button
  aria-label="Login to Finnova"
  (click)="sendForFinovaLogin()">
  <!-- <mat-icon>add</mat-icon>  -->
  <span> Login to Finnova </span>
  </button>

  <!-- <button color="primary" class="m-2 align-middle" mat-mini-fab aria-label="View notification">
    <mat-icon>notifications_none</mat-icon>
  </button> -->

  <!-- <button mat-raised-button [fxShow]="true" [fxShow.sm]="true" [fxShow.xs]="false" color="primary" class="profile_btn" [routerLink]="'/profile'">
    <mat-icon>person_outline</mat-icon>
    Profile
  </button> -->
  <!-- <button style="margin: 2%;" [fxShow]="false" [fxShow.sm]="false" [fxShow.xs]="true" mat-mini-fab [routerLink]="'/profile'">
    <mat-icon>person_outline</mat-icon>
  </button> -->

  <img
    style="cursor: pointer"
    fxFlex="1 1 7%"
    fxFlex.gt-sm="3%"
    mat-icon-button
    [matMenuTriggerFor]="dropMenu"
    [src]="'assets/icons/profile.svg'"
  />
  <!-- <mat-icon fxFlex style="font-size: x-large; margin-left: 1em; margin-right: 0.5em">person_outline</mat-icon> -->

  <mat-menu #dropMenu="matMenu" style="top: 0px; right: 0px">
    <ng-container *ngFor="let item of menuItems">
      <div [fxShow]="false" [fxShow.sm]="false" [fxShow.xs]="true">
        <button mat-menu-item>
          {{ item.label }}
        </button>
        <mat-divider></mat-divider>
      </div>
    </ng-container>
    <div class="jumbotron backgroundLightBlue text-center">
      <h5 class="mb-2">
        {{ hospitalName }}
      </h5>
      <h6>
        <span class="m-0" style="font-size: 12px; color: grey">
          Registered ID:
        </span>
        {{ registeredId }}
      </h6>
      <button
        [routerLink]="'/profile'"
        mat-flat-button
        color="primary"
        class="mt-2 mb-2"
      >
        View Profile
      </button>
      <!-- <qrcode qrdata="https://provider.trucvr.com/public/dashboard/{{registeredId}}" [errorCorrectionLevel]="'M'"></qrcode> -->
    </div>
    <button
      mat-menu-item
      class="example-icon"
      aria-label="Example icon-button with menu icon"
      (click)="doctorListRoute()"
      style="
        border: 0px;
        border-bottom: 1px;
        border-style: solid;
        border-color: rgba(179, 179, 179, 0.514);
      "
    >
      <mat-icon>person</mat-icon> Doctors List
    </button>
    <button
      mat-menu-item
      class="example-icon"
      aria-label="Example icon-button with menu icon"
      (click)="emailSupportRoute()"
      style="
        border: 0px;
        border-bottom: 1px;
        border-style: solid;
        border-color: rgba(179, 179, 179, 0.514);
      "
    >
      <mat-icon>alternate_email</mat-icon> Email Support
    </button>
    <button
      mat-menu-item
      class="example-icon"
      (click)="logout()"
      aria-label="Example icon-button with menu icon"
    >
      <mat-icon>exit_to_app</mat-icon> Logout
    </button>
  </mat-menu>
</mat-toolbar>
